import { render, staticRenderFns } from "./DisplayTimer.vue?vue&type=template&id=531b64e1&scoped=true&"
import script from "./DisplayTimer.vue?vue&type=script&lang=js&"
export * from "./DisplayTimer.vue?vue&type=script&lang=js&"
import style0 from "./DisplayTimer.vue?vue&type=style&index=0&id=531b64e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531b64e1",
  null
  
)

export default component.exports